import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { Accordion } from 'react-bootstrap';

const FAQ = () => {
    return (
        <Container className="text-center pt-5 ">
            <h2 className="text-center h1 ">
                FAQs: <span className="text-orange h3 ">Hearing Loss & Hearing Aids</span>
            </h2>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>How do I know if I need a hearing aid?</Accordion.Header>
                    <Accordion.Body>
                        A quick, painless hearing test at our clinic can tell you everything.
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                    <Accordion.Header>Are hearing machines affordable?</Accordion.Header>
                    <Accordion.Body>
                        Yes. We have devices starting from ₹6,000 with EMI options.
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                    <Accordion.Header> What is the best hearing aid in India?</Accordion.Header>
                    <Accordion.Body>
                        It depends on your hearing level, but Signia and Phonak are among the top-rated.
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                    <Accordion.Header> Is there a hearing aid clinic near me?</Accordion.Header>
                    <Accordion.Body>
                        Yes. We are in all major locations in Delhi NCR – just search “hearing aid store near
                        me” or “hearing machine near me.”
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

        </Container>
    );
};

export default FAQ;